import React, { useEffect, useState } from "react";
import PrimaryButton from "../components/PrimaryButton";
import bgRe from "@/assets/images/hmii.jpg";
import Div100vh from "react-div-100vh";
import { useNavigate } from "react-router-dom";
import {
  fetchJourneyWithGates,
  evaluateGate,
  GATE_DECISION,
} from "@/b2b/lib/journeyGates";

export default function HappyMoveIn({ theme }) {
  const navigate = useNavigate();

  const partner = localStorage.getItem("partnerIdentifier");
  const userIdentifier = localStorage.getItem("user_identifier");

  // This screen says "ONBOARDING COMPLETED" and had NO checks at all — it rendered on the
  // EMANDATE step alone, with no verification that a mandate exists or is live. It is reachable
  // five ways, and two of them are actively wrong: ProcessDisbursal routes here when NO
  // agreementLink is found, i.e. it announces completion BECAUSE a document is missing.
  //
  // So the same server verdict guards this screen. cpcore checks the mandate's STATUS and
  // deliberately ignores umrnNumber — NPCI issues a UMRN even for rejected eNACH, and 175
  // production mandates carry one while being cancelled or failed.
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      try {
        const { gates } = await fetchJourneyWithGates();
        if (cancelled) return;

        const verdict = evaluateGate(gates, "happyMoveIn");
        if (verdict.decision === GATE_DECISION.REDIRECT) {
          console.warn(
            "Happy Move-In withheld by the server gate:",
            verdict.reason,
            "->",
            verdict.fallbackStep
          );
          navigate(
            `/b/${userIdentifier}?partner=${partner}&step=${verdict.fallbackStep}`,
            { replace: true }
          );
          return;
        }
      } catch (error) {
        // Same narrow fail-open as Congrats: the server withholds by ANSWERING, so landing here
        // means we got no answer at all. Stranding a tenant who has genuinely finished their
        // onboarding would be worse than the defect being guarded against.
        console.error("Error verifying mandate status for happy-move-in", error);
      } finally {
        if (!cancelled) setVerifying(false);
      }
    };

    verify();
    return () => {
      cancelled = true;
    };
  }, []);

  const redirectionUrl = {
    housr: () => {
      navigate(
        `/b/${localStorage.getItem("user_identifier")}?step=back-to-base`
      );
    },
    xu: () => {
      window.location.href =
        "https://xulifestyle.com/zero-deposit/eligibility/success";
    },
  };

  // Render nothing until the verdict is in, so "ONBOARDING COMPLETED" cannot flash before we
  // redirect a tenant whose mandate is not actually active.
  if (verifying) return null;

  return (
    <Div100vh
      className={`flex flex-col justify-end bg-no-repeat bg-fill object-center bg-[${theme?.bgColor}]`}
    >
      <div
        className="z-10 p-8 flex flex-col justify-end gap-12 bg-no-repeat bg-cover object-center h-full w-full"
        style={{
          backgroundImage: `url(${bgRe})`,
        }}
      >
        <div className="flex flex-col gap-1 text-lg items-center text-[#010101]">
          <span className="tracking-widest font-medium">
            {" "}
            ONBOARDING COMPLETED{" "}
          </span>
          <span className="font-semibold text-xl">Happy Move-In</span>
        </div>

        <PrimaryButton text={"Done"} handleClick={redirectionUrl[partner]} />
      </div>
    </Div100vh>
  );
}
